import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function SistemaRuta() {
  return <section className="bg-[#1B2A4A] text-white py-20 px-6 overflow-hidden" data-id="element-363">
      <div className="max-w-5xl mx-auto" data-id="element-364">
        <FadeIn data-id="element-365">
          <div className="text-center mb-16" data-id="element-366">
            <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-367">
              El Sistema RUTA{' '}
              <span className="text-[#3BBFAD] text-2xl block mt-2 font-sans font-normal tracking-wide" data-id="element-368">
                (tu mecanismo)
              </span>
            </h2>
            <p className="text-xl text-gray-300" data-id="element-369">
              La Ruta Clara funciona porque no es “contenido”. Es un sistema.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-370">
          {/* R */}
          <FadeIn delay={100} data-id="element-371">
            <div className="bg-white/5 border border-white/10 p-6 rounded-xl hover:bg-white/10 transition-colors h-full" data-id="element-372">
              <div className="text-5xl font-serif text-[#3BBFAD] mb-4 opacity-80" data-id="element-373">
                R
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-374">Reconoce</h3>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-375">
                Señales que importan vs ruido (6 áreas clave) con ejemplos
                reales “en casa”.
              </p>
            </div>
          </FadeIn>

          {/* U */}
          <FadeIn delay={200} data-id="element-376">
            <div className="bg-white/5 border border-white/10 p-6 rounded-xl hover:bg-white/10 transition-colors h-full" data-id="element-377">
              <div className="text-5xl font-serif text-[#F5A623] mb-4 opacity-80" data-id="element-378">
                U
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-379">Ubica</h3>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-380">
                Qué cambia a los 18 vs 24 meses (cuándo vigilar y cuándo
                actuar).
              </p>
            </div>
          </FadeIn>

          {/* T */}
          <FadeIn delay={300} data-id="element-381">
            <div className="bg-white/5 border border-white/10 p-6 rounded-xl hover:bg-white/10 transition-colors h-full" data-id="element-382">
              <div className="text-5xl font-serif text-[#3BBFAD] mb-4 opacity-80" data-id="element-383">
                T
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-384">Tracking</h3>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-385">
                5 minutos al día por 7 días. Registro simple que se entiende en
                consulta.
              </p>
            </div>
          </FadeIn>

          {/* A */}
          <FadeIn delay={400} data-id="element-386">
            <div className="bg-white/5 border border-white/10 p-6 rounded-xl hover:bg-white/10 transition-colors h-full" data-id="element-387">
              <div className="text-5xl font-serif text-[#F5A623] mb-4 opacity-80" data-id="element-388">
                A
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-389">Acción</h3>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-390">
                Plan de 14 días: Pediatra → Early Intervention → próximos pasos,
                con guiones.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}